import { cloneDeep, each, merge, get, isEmpty, update, isEqual, keys } from 'lodash';
import { createStore } from 'redux';
import produce__default, { produce } from 'immer';
export * from 'immer';

/**
 * 属性类型定义
 */
var PROPS_TYPES;
(function (PROPS_TYPES) {
    PROPS_TYPES["object"] = "object";
    PROPS_TYPES["objectArray"] = "objectArray";
    PROPS_TYPES["function"] = "function";
    PROPS_TYPES["number"] = "number";
    PROPS_TYPES["numberArray"] = "numberArray";
    PROPS_TYPES["string"] = "string";
    PROPS_TYPES["stringArray"] = "stringArray";
    PROPS_TYPES["enum"] = "enum";
    PROPS_TYPES["json"] = "json";
    PROPS_TYPES["boolean"] = "boolean";
    PROPS_TYPES["style"] = "style";
    PROPS_TYPES["cssClass"] = "cssClass";
})(PROPS_TYPES || (PROPS_TYPES = {}));
var NODE_PROPS_TYPES;
(function (NODE_PROPS_TYPES) {
    NODE_PROPS_TYPES["reactNode"] = "reactNode";
    NODE_PROPS_TYPES["functionReactNode"] = "functionReactNode";
})(NODE_PROPS_TYPES || (NODE_PROPS_TYPES = {}));

var ACTION_TYPES = {
    submitConfigs: `submitConfigs`,
    searchTemplate: `searchTemplate`,
    getTemplateList: `getTemplateList`,
    outputFiles: `outputFiles`,
    addTemplateInfo: `addTemplateInfo`,
    deleteTemplate: `deleteTemplate`,
    saveTemplateInfos: `saveTemplateInfos`,
    addComponent: `addComponent`,
    copyComponent: `copyComponent`,
    onLayoutSortChange: `onLayoutSortChange`,
    clearSelectedStatus: `clearSelectedStatus`,
    selectComponent: `selectComponent`,
    clearChildNodes: `clearChildNodes`,
    deleteComponent: `deleteComponent`,
    changeStyles: `changeStyles`,
    changeVisualizedStyles: 'changeVisualizedStyles',
    changeProps: `changeProps`,
    undo: `undo`,
    redo: `redo`,
    changePlatform: `changePlatform`,
    resetProps: 'resetProps',
    initPageBrickdState: 'initPageBrickdState',
    createLayers: 'createLayers',
    deleteLayers: 'deleteLayers',
    copyLayers: 'copyLayers',
    renameLayers: 'renameLayers',
    changeLayer: 'changeLayer',
    changeSeniorProps: 'changeSeniorProps',
};

/**
 * 拖拽排序 缓存
 */
let DRAG_SORT_CACHE = null;
/**
 * 新拖拽 Key
 */
let NEW_DRAG_KEY = null;
const getNewDragKey = () => NEW_DRAG_KEY;
const setNewDragKey = (key) => (NEW_DRAG_KEY = key);
const setDragSortCache = (dragSort) => (DRAG_SORT_CACHE = dragSort);
const getDragSortCache = () => DRAG_SORT_CACHE;
let WARN = null;
const getWarn = () => WARN;
const setWarn = (warn) => (WARN = warn);
/**
 * store 缓存
 */
let STORE = null;
const setStore = (store) => (STORE = store);
const getStore = () => STORE;
/**
 * 全局配置缓存
 */
let BRICKD_CONFIG = null;
const getBrickdConfig = () => BRICKD_CONFIG;
const setBrickdConfig = (config) => (BRICKD_CONFIG = config);
let DRAG_SOURCE = null;
const getDragSource = () => DRAG_SOURCE;
const setDragSource = (dragSource) => {
    if (!dragSource)
        return DRAG_SOURCE = dragSource;
    dragSource = cloneDeep(dragSource);
    const RootState = STORE.getState();
    const { layerName } = RootState;
    if (!layerName)
        return;
    let { template, dragKey } = dragSource;
    const { componentName, defaultProps, parentKey, parentPropName } = dragSource;
    /**
     * componentName有值说明为新添加的组件，为其生成vDom
     */
    dragKey = dragKey || ROOT;
    if (componentName) {
        template = {
            [ROOT]: {
                componentName: componentName,
                props: defaultProps,
            },
        };
    }
    const { pageConfig } = RootState[layerName];
    /**
     * 如果componentConfigs有根节点并且vDOMCollection有值，就将vDOMCollection中的
     * vDom合并到componentConfigs，为实时拖拽预览做准备
     */
    if (pageConfig[ROOT] && template) {
        const newKey = getNewKey(pageConfig);
        dragKey = `${newKey}`;
        setNewDragKey(dragKey);
        template = generateNewKey(template, newKey);
    }
    DRAG_SOURCE = {
        template,
        dragKey,
        parentKey,
        parentPropName
    };
};
const setDragSourceStyle = (style) => {
    DRAG_SOURCE.style = style;
};
/**
 * 拖放目标 缓存
 */
let DROP_TARGET = null;
const getDropTarget = () => DROP_TARGET;
const setDropTarget = (dropTarget) => DROP_TARGET = dropTarget;
const cleanStateCache = () => {
    setBrickdConfig(null);
    setWarn(null);
    setStore(null);
    setDragSortCache(null);
    setDropTarget(null);
    setDragSource(null);
    setNewDragKey(null);
};

const legoState = {
    pageConfig: {},
    selectedInfo: null,
    undo: [],
    redo: [],
    platformInfo: { platformName: 'PC', size: ['100%', '100%'] },
};
function initPageBrickdState(state, payload) {
    const newState = {};
    const layerName = Object.keys(payload)[0];
    each(payload, (v, k) => {
        newState[k] = merge(v, legoState);
    });
    return { layerName, ...newState };
}

/**
 * 根节点key
 */
const ROOT = '0';
/**
 * 复制组件
 * @param pageConfig
 * @param selectedKey
 * @param newKey
 */
const copyConfig = (pageConfig, selectedKey, newKey) => {
    const vDom = pageConfig[selectedKey];
    const childNodes = vDom.childNodes;
    if (!childNodes) {
        pageConfig[newKey] = vDom;
    }
    else {
        const newVDom = { ...vDom };
        pageConfig[newKey] = newVDom;
        if (Array.isArray(childNodes)) {
            newVDom.childNodes = copyChildNodes(pageConfig, childNodes);
        }
        else {
            const newChildNodes = {};
            each(childNodes, (nodes, propName) => {
                newChildNodes[propName] = copyChildNodes(pageConfig, nodes);
            });
            newVDom.childNodes = newChildNodes;
        }
    }
};
function copyChildNodes(pageConfig, childNodes) {
    const newChildKeys = [];
    for (const oldKey of childNodes) {
        const newChildKey = getNewKey(pageConfig);
        newChildKeys.push(`${newChildKey}`);
        copyConfig(pageConfig, oldKey, newChildKey);
    }
    return newChildKeys;
}
function deleteChildNodes(pageConfig, childNodes, propName) {
    if (Array.isArray(childNodes)) {
        deleteArrChild(pageConfig, childNodes);
    }
    else {
        each(childNodes, (propChildNodes, key) => {
            if (propName) {
                if (key === propName) {
                    deleteArrChild(pageConfig, propChildNodes);
                }
            }
            else {
                deleteArrChild(pageConfig, propChildNodes);
            }
        });
    }
}
function deleteArrChild(pageConfig, childNodes) {
    for (const key of childNodes) {
        const childNodesInfo = pageConfig[key].childNodes;
        if (childNodesInfo) {
            deleteChildNodes(pageConfig, childNodesInfo);
        }
        delete pageConfig[key];
    }
}
/**
 * 获取路径
 * */
function getLocation(key, propName) {
    const basePath = [key, 'childNodes'];
    return propName ? [...basePath, propName] : basePath;
}
/**
 * 生成新的Key
 * @param rootKey
 */
const generateNewKey = (template, rootKey) => {
    const keyMap = {};
    const newVDOMCollection = {};
    let newKey = rootKey;
    each(template, (vDom, key) => {
        ++newKey;
        if (key === ROOT) {
            newKey = rootKey;
        }
        keyMap[key] = `${newKey}`;
        newVDOMCollection[newKey] = vDom;
    });
    each(newVDOMCollection, (vDom) => {
        const childNodes = vDom.childNodes;
        if (!childNodes)
            return;
        if (Array.isArray(childNodes)) {
            vDom.childNodes = childNodes.map((key) => keyMap[key]);
        }
        else {
            const newChildNodes = {};
            each(childNodes, (nodes, propName) => {
                newChildNodes[propName] = nodes.map((key) => keyMap[key]);
            });
            vDom.childNodes = newChildNodes;
        }
    });
    return newVDOMCollection;
};
/**
 * 获取字段在props中的位置
 * @param fieldConfigLocation
 * @returns {string}
 */
const getFieldInPropsLocation = (fieldConfigLocation) => {
    return fieldConfigLocation
        .split('.')
        .filter((location) => location !== 'childPropsConfig');
};
/**
 * 处理子节点非空
 * @param selectedInfo
 * @param pageConfig
 * @param payload
 */
const handleRequiredHasChild = (selectedInfo, pageConfig) => {
    const { selectedKey, propName: selectedPropName } = selectedInfo;
    const { componentName, childNodes } = pageConfig[selectedKey];
    const { nodePropsConfig, isRequired } = getComponentConfig(componentName);
    return ((get(nodePropsConfig, [selectedPropName, 'isRequired']) &&
        !get(childNodes, selectedPropName)) ||
        (isRequired && !childNodes));
};
function shallowEqual(objA, objB) {
    for (const k of Object.keys(objA)) {
        if (objA[k] !== objB[k])
            return false;
    }
    return true;
}
function deleteChildNodesKey(childNodes, deleteKey, parentPropName) {
    if (Array.isArray(childNodes)) {
        const resultChildNodes = childNodes.filter((nodeKey) => nodeKey !== deleteKey);
        return restObject(resultChildNodes);
    }
    else {
        const resultChildNodes = childNodes[parentPropName].filter((nodeKey) => nodeKey !== deleteKey);
        if (resultChildNodes.length === 0) {
            delete childNodes[parentPropName];
        }
        else {
            childNodes[parentPropName] = resultChildNodes;
        }
        return restObject(childNodes);
    }
}
function getComponentConfig(componentName, key) {
    if (key) {
        const { pageConfig } = getSelector(['pageConfig']);
        componentName = get(pageConfig, key + '.componentName');
    }
    if (!componentName)
        return { propsConfig: {} };
    const componentSchemasMap = get(getBrickdConfig(), ['componentSchemasMap']);
    if (!componentSchemasMap) {
        error('Component configuration information set not found！! !');
    }
    const componentSchema = componentSchemasMap[componentName];
    if (componentName && !componentSchema) {
        warn(`${componentName} configuration information not found！! !`);
    }
    return componentSchema;
}
function isContainer(componentName) {
    return !get(getBrickdConfig(), [
        'componentSchemasMap',
        componentName,
        'isNonContainer',
    ]);
}
function error(msg) {
    console.error(msg);
    throw new Error(msg);
}
function warn(msg) {
    const warn = getWarn();
    if (warn) {
        warn(msg);
    }
    else {
        console.warn(msg);
    }
    return true;
}
function getNewKey(pageConfig) {
    const lastKey = Object.keys(pageConfig).pop();
    return Number(lastKey) + 1;
}
function restObject(obj, field) {
    if (field) {
        delete obj[field];
    }
    if (Object.keys(obj).length === 0)
        return undefined;
    return obj;
}
function handleRules(pageConfig, isForbid) {
    /**
     * 获取当前拖拽组件的父组件约束，以及属性节点配置信息
     */
    const { dragKey, template } = getDragSource() || {};
    const { dropKey, propName } = getDropTarget() || {};
    const path = [dragKey, 'componentName'];
    const dragComponentName = get(pageConfig, path) || get(template, path);
    const dropComponentName = get(pageConfig, [dropKey, 'componentName']);
    const { fatherNodesRule } = getComponentConfig(dragComponentName);
    const { nodePropsConfig, childNodesRule } = getComponentConfig(dropComponentName);
    /**
     * 子组件约束限制，减少不必要的组件错误嵌套
     */
    const childRules = propName
        ? get(nodePropsConfig, [propName, 'childNodesRule'])
        : childNodesRule;
    if (childRules && !childRules.includes(dragComponentName)) {
        !isForbid &&
            warn(`${propName || dropComponentName}:only allow drag and drop to add${childRules.toString()}`);
        return true;
    }
    /**
     * 父组件约束限制，减少不必要的组件错误嵌套
     */
    if (fatherNodesRule &&
        !fatherNodesRule.includes(propName ? `${dropComponentName}.${propName}` : `${dropComponentName}`)) {
        !isForbid &&
            warn(`${dragComponentName}:Only allowed as a child node or attribute node of${fatherNodesRule.toString()}`);
        return true;
    }
    return false;
}
function combineReducers(brickReducer, customReducer) {
    return (state, action) => {
        const newState = brickReducer(state, action);
        if (customReducer) {
            return customReducer(newState, action);
        }
        else {
            return newState;
        }
    };
}
function createTemplateConfigs(templateConfigs, pageConfig, childNodes) {
    if (Array.isArray(childNodes)) {
        for (const key of childNodes) {
            templateConfigs[key] = pageConfig[key];
            const { childNodes } = templateConfigs[key];
            if (childNodes)
                createTemplateConfigs(templateConfigs, pageConfig, childNodes);
        }
    }
    else {
        each(childNodes, (childKeys) => {
            if (!isEmpty(childKeys))
                createTemplateConfigs(templateConfigs, pageConfig, childKeys);
        });
    }
}
function createTemplate(state) {
    const { selectedInfo, pageConfig } = state;
    const { selectedKey } = selectedInfo;
    const templateConfigs = { [ROOT]: pageConfig[selectedKey] };
    const { childNodes } = pageConfig[selectedKey];
    if (!isEmpty(childNodes)) {
        createTemplateConfigs(templateConfigs, pageConfig, childNodes);
    }
    return templateConfigs;
}
function createActions(action) {
    return getStore().dispatch(action);
}
function getPageState(isRoot) {
    const store = getStore();
    if (!store)
        return legoState;
    const brickdState = store.getState();
    if (isRoot)
        return brickdState;
    const layerName = get(brickdState, 'layerName');
    return get(brickdState, layerName, legoState);
}
function getSelector(selector) {
    const states = getPageState();
    const resultState = {};
    each(selector, (stateName) => (resultState[stateName] = states[stateName]));
    return resultState;
}

const addComponent = () => createActions({ type: ACTION_TYPES.addComponent });
const copyComponent = (payload) => createActions({ type: ACTION_TYPES.copyComponent, payload });
const onLayoutSortChange = (payload) => createActions({
    type: ACTION_TYPES.onLayoutSortChange,
    payload,
});
const deleteComponent = (payload) => createActions({ type: ACTION_TYPES.deleteComponent, payload });
const clearChildNodes = (payload) => createActions({ type: ACTION_TYPES.clearChildNodes, payload });

const changePlatform = (payload) => createActions({
    type: ACTION_TYPES.changePlatform,
    payload,
});

const changeProps = (payload) => createActions({
    type: ACTION_TYPES.changeProps,
    payload,
});
const resetProps = () => createActions({ type: ACTION_TYPES.resetProps });

const undo = () => createActions({ type: ACTION_TYPES.undo });
const redo = () => createActions({ type: ACTION_TYPES.redo });

const selectComponent = (payload) => createActions({
    type: ACTION_TYPES.selectComponent,
    payload,
});
const clearSelectedStatus = () => createActions({ type: ACTION_TYPES.clearSelectedStatus });

const changeStyles = (payload) => createActions({
    type: ACTION_TYPES.changeStyles,
    payload,
});
const changeVisualizedStyles = (payload) => createActions({ type: ACTION_TYPES.changeVisualizedStyles, payload });

const initPageBrickdState$1 = (payload) => createActions({ type: ACTION_TYPES.initPageBrickdState, payload });

const createLayers = (payload) => createActions({ type: ACTION_TYPES.createLayers, payload });
const deleteLayers = (payload) => createActions({
    type: ACTION_TYPES.deleteLayers,
    payload,
});
const copyLayers = (payload) => createActions({
    type: ACTION_TYPES.copyLayers,
    payload,
});
const renameLayers = (payload) => createActions({ type: ACTION_TYPES.renameLayers, payload });
const changeLayer = (payload) => createActions({ type: ACTION_TYPES.changeLayer, payload });

const changeSeniorProps = (payload) => createActions({
    type: ACTION_TYPES.changeSeniorProps,
    payload,
});

/**
 * 往画板或者容器组件添加组件
 * @param state
 * @returns {{pageConfig: *}}
 */
function addComponent$1(state) {
    const { undo, redo, pageConfig } = state;
    /**
     * 如果没有拖拽的组件不做添加动作, 如果没有
     */
    const dragSource = getDragSource(), dropTarget = getDropTarget();
    if (!dragSource || (!dropTarget && pageConfig[ROOT])) {
        return state;
    }
    const { template, dragKey, parentKey, parentPropName, style } = dragSource;
    setDragSource(null);
    /**
     * 如果没有root根节点，新添加的组件添加到root
     */
    if (!pageConfig[ROOT]) {
        undo.push({ pageConfig });
        redo.length = 0;
        return {
            ...state,
            pageConfig: template,
            undo,
            redo,
        };
    }
    // eslint-disable-next-line prefer-const
    let { dropKey, propName, childNodeKeys } = dropTarget;
    setDropTarget(null);
    /**
     * 如果有root根节点，并且即没有选中的容器组件也没有drop的目标，那么就要回退到drag目标，
     * 添加之前的页面配置
     */
    const dragSort = getDragSortCache();
    if (!dragSort ||
        (parentKey === dropKey && isEqual(childNodeKeys, dragSort)) ||
        handleRules(pageConfig)) {
        return state;
    }
    parentKey && undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce(pageConfig, (oldConfigs) => {
            //添加新组件到指定容器中
            if (style) {
                let node;
                if (template) {
                    node = template[dragKey];
                }
                else {
                    node = oldConfigs[dragKey];
                }
                update(node, 'props.style', (oldStyle = {}) => {
                    return { ...oldStyle, ...style };
                });
            }
            console.log('template>>>>>>>>>', template);
            template && Object.assign(oldConfigs, template);
            update(oldConfigs, getLocation(dropKey, propName), () => dragSort);
            //如果有父key说明是跨组件的拖拽，原先的父容器需要删除该组件的引用
            if (parentKey &&
                (parentKey !== dropKey || parentPropName !== propName)) {
                update(oldConfigs, getLocation(parentKey), (childNodes) => deleteChildNodesKey(childNodes, dragKey, parentPropName));
            }
        }),
        undo,
        redo,
    };
}
/**
 * 复制组件
 * @param state
 * @returns {{pageConfig: *}}
 */
function copyComponent$1(state, payload) {
    const { undo, redo, pageConfig, selectedInfo } = state;
    const { key } = payload;
    /**
     * 未选中组件不做任何操作
     */
    if (!selectedInfo && !key) {
        warn('Please select the node you want to copy');
        return state;
    }
    if (get(selectedInfo, 'selectedKey') === ROOT || key === ROOT) {
        warn('Prohibit copying root node');
        return state;
    }
    const { selectedKey, parentPropName, parentKey } = selectedInfo || {};
    undo.push({ pageConfig });
    redo.length = 0;
    const newKey = getNewKey(pageConfig);
    return {
        ...state,
        pageConfig: produce(pageConfig, (oldState) => {
            update(oldState, getLocation(parentKey || payload.parentKey, parentPropName || payload.parentPropName), (childNodes) => [...childNodes, `${newKey}`]);
            copyConfig(oldState, selectedKey || key, newKey);
        }),
        undo,
        redo,
    };
}
/**
 * 当domTree中拖拽节点调整顺序时触发
 * @param state
 * @param payload
 * @returns {{pageConfig: *}}
 */
function onLayoutSortChange$1(state, payload) {
    const { sortKeys, parentKey, parentPropName, dragInfo } = payload;
    const { undo, redo, pageConfig } = state;
    undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce(pageConfig, (oldConfigs) => {
            update(oldConfigs, getLocation(parentKey, parentPropName), () => sortKeys);
            /**
             * dragInfo有值说明为跨组件排序，需要删除拖拽组件原先父组件中的引用
             */
            if (dragInfo &&
                (dragInfo.parentKey !== parentKey ||
                    dragInfo.parentPropName !== parentPropName)) {
                const { key, parentKey, parentPropName } = dragInfo;
                update(oldConfigs, getLocation(parentKey), (childNodes) => deleteChildNodesKey(childNodes, key, parentPropName));
            }
        }),
        undo,
        redo,
    };
}
/**
 * 删除组件
 * @param state
 * @returns {{propsSetting: *, pageConfig: *, selectedInfo: *}}
 */
function deleteComponent$1(state, payload) {
    const { key } = payload;
    const { undo, redo, pageConfig, selectedInfo } = state;
    /**
     * 未选中组件将不做任何操作
     */
    if (!selectedInfo && !key) {
        warn('Please select the components you want to delete');
        return state;
    }
    const { selectedKey, parentKey, parentPropName } = selectedInfo || {};
    undo.push({ pageConfig, selectedInfo });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce(pageConfig, (oldState) => {
            /**
             * 如果选中的是根节点说明要删除整个页面
             */
            if (selectedKey === ROOT || key === ROOT) {
                return {};
            }
            else {
                // 删除选中组件在其父组件中的引用
                update(oldState, getLocation(parentKey || payload.parentKey), (childNodes) => deleteChildNodesKey(childNodes, selectedKey, parentPropName || payload.parentPropName));
                const childNodes = oldState[selectedKey || key].childNodes;
                /**
                 * 如果childNodes有值，就遍历childNodes删除其中的子节点
                 */
                if (childNodes) {
                    deleteChildNodes(oldState, childNodes);
                }
                delete oldState[selectedKey || key];
            }
        }),
        selectedInfo: null,
        undo,
        redo,
    };
}
/**
 * 清除所有子节点
 * @param state
 * @returns {{undo: *, pageConfig, redo: *}}
 */
function clearChildNodes$1(state, payload) {
    const { pageConfig, selectedInfo, undo, redo } = state;
    const { key } = payload;
    if (!selectedInfo || !key) {
        warn('Please select the component or property you want to clear the child nodes');
        return state;
    }
    const { selectedKey, propName } = selectedInfo;
    const childNodes = get(pageConfig, getLocation(selectedKey));
    if (!childNodes)
        return state;
    undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce(pageConfig, (oldState) => {
            deleteChildNodes(oldState, childNodes, propName);
            update(oldState, getLocation(selectedKey), (childNodes) => {
                /**
                 * 如果 没有propName说明要清除组件的所有子节点
                 */
                if (!propName) {
                    return undefined;
                }
                else {
                    return restObject(childNodes, propName);
                }
            });
        }),
        undo,
        redo,
    };
}

/**
 * 更改平台
 * @param state
 * @param payload
 */
function changePlatform$1(state, payload) {
    const { platformInfo } = state;
    return {
        ...state,
        platformInfo: { ...platformInfo, ...payload },
    };
}

/**
 * 提交属性
 * @param state
 * @param payload
 * @returns {{propsSetting: *, pageConfig: *}}
 */
function changeProps$1(state, payload) {
    const { pageConfig, selectedInfo, undo, redo } = state;
    if (!selectedInfo)
        return state;
    const { props, isMerge } = payload;
    const { selectedKey } = selectedInfo;
    undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce__default(pageConfig, (oldConfigs) => {
            if (isMerge) {
                const originalProps = oldConfigs[selectedKey].props;
                oldConfigs[selectedKey].props = { ...originalProps, ...props };
            }
            else {
                const style = get(oldConfigs, [selectedKey, 'props', 'style']);
                if (style) {
                    oldConfigs[selectedKey].props = { ...props, style };
                }
                else {
                    oldConfigs[selectedKey].props = props;
                }
            }
        }),
        undo,
        redo,
    };
}
/**
 * 重置属性
 * @param state
 */
function resetProps$1(state) {
    const { selectedInfo, pageConfig, undo, redo } = state;
    if (!selectedInfo)
        return state;
    const { selectedKey, props } = selectedInfo;
    undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce__default(pageConfig, (oldConfigs) => {
            const style = get(oldConfigs, [selectedKey, 'props', 'style']);
            if (style) {
                oldConfigs[selectedKey].props = { ...props, style };
            }
            else {
                oldConfigs[selectedKey].props = props;
            }
        }),
        undo,
        redo,
    };
}

/**
 * 选中组件
 * @param state
 * @param payload
 * @returns {{ undo: *, propsSetting: {propsConfig, mergePropsConfig, addPropsConfig: *, props: *}, redo: *, selectedInfo: {selectedKey: *, location: *, domTreeKeys: *[], fatherLocation: *, isContainer: boolean, style: *, componentName: *, nodePropsConfig}}}
 */
function selectComponent$1(state, payload) {
    const { undo, redo, selectedInfo, pageConfig } = state;
    const { propName, domTreeKeys, key, parentKey, parentPropName, selectedStyleProp } = payload;
    // if (selectedInfo) {
    //   const { selectedKey, propName: selectedPropName } = selectedInfo;
    //   if (
    //     (selectedKey === key && selectedPropName == propName) ||
    //     handleRequiredHasChild(selectedInfo, pageConfig)
    //   )
    //     return state;
    //   if (selectedKey === key) {
    //     if (propName && selectedPropName !== propName) {
    //       domTreeKeys.push(`${key}${propName}`);
    //       return {
    //         ...state,
    //         selectedInfo: {
    //           ...selectedInfo,
    //           propName,
    //           domTreeKeys,
    //         },
    //       };
    //     } else {
    //       return {
    //         ...state,
    //         selectedInfo: {
    //           ...selectedInfo,
    //           parentKey,
    //           parentPropName,
    //         },
    //       };
    //     }
    //   }
    // }
    propName && domTreeKeys.push(`${key}${propName}`);
    const { props, componentName } = pageConfig[key];
    const { propsConfig } = getComponentConfig(componentName);
    undo.push({ selectedInfo });
    redo.length = 0;
    return {
        ...state,
        selectedInfo: {
            selectedKey: key,
            propName,
            domTreeKeys,
            parentKey,
            parentPropName,
            props,
            propsConfig,
            selectedStyleProp
        },
        undo,
        redo,
    };
}
/**
 * 清除选中状态
 * @param state
 * @returns {{undo: *, propsSetting: {}, redo: *, selectedInfo: {}}}
 */
function clearSelectedStatus$1(state) {
    const { selectedInfo, pageConfig, undo, redo } = state;
    if (!selectedInfo || handleRequiredHasChild(selectedInfo, pageConfig)) {
        return state;
    }
    undo.push({ selectedInfo });
    redo.length = 0;
    return {
        ...state,
        selectedInfo: null,
        undo,
        redo,
    };
}

/**
 * 样式改变时调用
 * @param state
 * @param payload
 * @returns {{propsSetting: *, pageConfig: *}|*}
 */
function changeStyles$1(state, payload) {
    const { undo, redo, selectedInfo, styleSheet, pageConfig } = state;
    if (!selectedInfo)
        return state;
    const { style, isMerge } = payload;
    const { selectedKey, selectedStyleProp } = selectedInfo;
    if (!selectedStyleProp) {
        undo.push({ pageConfig });
        redo.length = 0;
        return {
            ...state,
            pageConfig: produce__default(pageConfig, (oldConfigs) => {
                const config = oldConfigs[selectedKey];
                if (get(config.props, 'style') && isMerge) {
                    config.props.style = { ...config.props.style, ...style };
                }
                else {
                    if (config.props) {
                        config.props.style = style;
                    }
                    else {
                        config.props = { style };
                    }
                }
            }),
            undo,
            redo,
        };
    }
    undo.push({ styleSheet });
    redo.length = 0;
    return {
        ...state,
        styleSheet: produce__default(styleSheet || {}, (oldStyleSheet) => {
            oldStyleSheet[selectedKey + selectedStyleProp] = style;
        }),
        undo,
        redo,
    };
}
function changeVisualizedStyles$1(state, payload) {
    const { undo, redo, selectedInfo, styleSheet, pageConfig } = state;
    if (!selectedInfo)
        return state;
    const { selectedKey, selectedStyleProp, } = selectedInfo;
    const { width, height } = payload;
    if (!selectedStyleProp) {
        if (width || height) {
            undo.push({ pageConfig });
            redo.length = 0;
        }
        return {
            ...state,
            pageConfig: produce__default(pageConfig, (oldConfigs) => {
                if (width) {
                    update(oldConfigs[selectedKey], 'props.style.width', () => width);
                }
                if (height) {
                    update(oldConfigs[selectedKey], 'props.style.height', () => height);
                }
            }),
        };
    }
    if (width || height) {
        undo.push({ styleSheet });
        redo.length = 0;
    }
    return {
        ...state,
        styleSheet: produce__default(styleSheet || {}, (oldStyleSheet) => {
            update(oldStyleSheet, [selectedKey + selectedStyleProp], (value) => merge(value, payload));
        }),
        undo,
        redo,
    };
}

/**
 * 撤销
 * @param state
 * @returns {(*&void&{undo: *, redo: *})|(*&T&{undo: *, redo: *})}
 */
function undo$1(state) {
    const { undo, redo } = state;
    if (undo.length == 0)
        return state;
    const nextState = undo.pop();
    const prevState = {};
    each(nextState, (_, key) => (prevState[key] = get(state, key)));
    redo.push(prevState);
    return {
        ...state,
        ...nextState,
        undo,
        redo,
    };
}
/**
 * 重做
 * @param state
 * @returns {(*&void&{undo: *, redo: *})|(*&T&{undo: *, redo: *})}
 */
function redo$1(state) {
    const { undo, redo } = state;
    if (redo.length == 0)
        return state;
    const nextState = redo.pop();
    const prevState = {};
    each(nextState, (_, key) => (prevState[key] = get(state, key)));
    undo.push(prevState);
    return {
        ...state,
        ...nextState,
        undo,
        redo,
    };
}

function createLayers$1(state, payload) {
    const { layerName } = payload;
    return {
        ...state,
        layerName,
        [layerName]: legoState,
    };
}
function deleteLayers$1(state, payload) {
    const { layerName } = payload;
    const { layerName: selectedLayerName } = state;
    delete state[layerName];
    const layers = keys(state);
    layers.shift();
    const newLayerName = selectedLayerName === layerName ? layers[0] : selectedLayerName;
    return {
        ...state,
        layerName: newLayerName,
    };
}
function renameLayers$1(state, payload) {
    const { newLayerName, prevLayerName } = payload;
    const prevState = state[prevLayerName];
    delete state[prevLayerName];
    return {
        ...state,
        layerName: newLayerName,
        [newLayerName]: prevState,
    };
}
function changeLayer$1(state, payload) {
    const { layerName } = payload;
    if (state.layerName === layerName)
        return state;
    return {
        ...state,
        layerName,
    };
}
function copyLayers$1(state, payload) {
    const { layerName } = payload;
    const brickKeys = keys(state);
    let copyIndex = 0;
    each(brickKeys, (key) => {
        if (key.includes(layerName)) {
            copyIndex++;
        }
    });
    const newLayerName = layerName + copyIndex;
    return {
        ...state,
        [newLayerName]: state[layerName],
    };
}

/**
 * 提交属性
 * @param state
 * @param payload
 * @returns {{propsSetting: *, pageConfig: *}}
 */
function changeSeniorProps$1(state, payload) {
    const { pageConfig, selectedInfo, undo, redo } = state;
    if (!selectedInfo)
        return state;
    const { props } = payload;
    const { selectedKey } = selectedInfo;
    undo.push({ pageConfig });
    redo.length = 0;
    return {
        ...state,
        pageConfig: produce__default(pageConfig, (oldConfigs) => {
            const cConfig = oldConfigs[selectedKey];
            oldConfigs[selectedKey] = { ...cConfig, ...props };
        }),
        undo,
        redo,
    };
}

const reducer = (prevState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.createLayers:
            return createLayers$1(prevState, payload);
        case ACTION_TYPES.deleteLayers:
            return deleteLayers$1(prevState, payload);
        case ACTION_TYPES.renameLayers:
            return renameLayers$1(prevState, payload);
        case ACTION_TYPES.copyLayers:
            return copyLayers$1(prevState, payload);
        case ACTION_TYPES.changeLayer:
            return changeLayer$1(prevState, payload);
        case ACTION_TYPES.initPageBrickdState:
            return initPageBrickdState(prevState, payload);
    }
    const layerName = get(prevState, 'layerName');
    if (!layerName)
        return prevState;
    const state = get(prevState, layerName, legoState);
    let newState;
    switch (type) {
        case ACTION_TYPES.addComponent:
            newState = addComponent$1(state);
            break;
        case ACTION_TYPES.clearChildNodes:
            newState = clearChildNodes$1(state, payload);
            break;
        case ACTION_TYPES.onLayoutSortChange:
            newState = onLayoutSortChange$1(state, payload);
            break;
        case ACTION_TYPES.deleteComponent:
            newState = deleteComponent$1(state, payload);
            break;
        case ACTION_TYPES.copyComponent:
            newState = copyComponent$1(state, payload);
            break;
        case ACTION_TYPES.changePlatform:
            newState = changePlatform$1(state, payload);
            break;
        case ACTION_TYPES.changeProps:
            newState = changeProps$1(state, payload);
            break;
        case ACTION_TYPES.selectComponent:
            newState = selectComponent$1(state, payload);
            break;
        case ACTION_TYPES.clearSelectedStatus:
            newState = clearSelectedStatus$1(state);
            break;
        case ACTION_TYPES.changeStyles:
            newState = changeStyles$1(state, payload);
            break;
        case ACTION_TYPES.undo:
            newState = undo$1(state);
            break;
        case ACTION_TYPES.redo:
            newState = redo$1(state);
            break;
        case ACTION_TYPES.resetProps:
            newState = resetProps$1(state);
            break;
        case ACTION_TYPES.changeVisualizedStyles:
            newState = changeVisualizedStyles$1(state, payload);
            break;
        case ACTION_TYPES.changeSeniorProps:
            newState = changeSeniorProps$1(state, payload);
            break;
        default:
            return prevState;
    }
    if (newState === state)
        return prevState;
    return { ...prevState, [layerName]: newState };
};

function createLegoStore(config, customReducer, warn) {
    if (warn)
        setWarn(warn);
    if (getBrickdConfig() && !config) {
        throw Error('config未初始化');
    }
    else if (!getBrickdConfig()) {
        setBrickdConfig(config);
    }
    if (getStore())
        return getStore();
    const store = createStore(combineReducers(reducer, customReducer), window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__());
    const legoStore = { ...store, getPageState };
    setStore(legoStore);
    return legoStore;
}

export { NODE_PROPS_TYPES, PROPS_TYPES, ROOT, addComponent, changeLayer, changePlatform, changeProps, changeSeniorProps, changeStyles, changeVisualizedStyles, cleanStateCache, clearChildNodes, clearSelectedStatus, combineReducers, copyComponent, copyConfig, copyLayers, createActions, createLayers, createLegoStore, createTemplate, createTemplateConfigs, deleteChildNodes, deleteChildNodesKey, deleteComponent, deleteLayers, error, generateNewKey, getBrickdConfig, getComponentConfig, getDragSortCache, getDragSource, getDropTarget, getFieldInPropsLocation, getLocation, getNewDragKey, getNewKey, getPageState, getSelector, getStore, getWarn, handleRequiredHasChild, handleRules, initPageBrickdState$1 as initPageBrickdState, isContainer, onLayoutSortChange, redo, renameLayers, resetProps, restObject, selectComponent, setBrickdConfig, setDragSortCache, setDragSource, setDragSourceStyle, setDropTarget, setNewDragKey, setStore, setWarn, shallowEqual, undo, warn };
